import React, { useState } from 'react';
import SingleBottomNav from 'components/base/single-bottom-nav';
import { Button, Input, Textarea, ToastMessage } from '@cokitchen/cokitchen-components';
import './styles.scss';
import { SuccessModal } from 'components/base/success-modal';
import SelectBrand from 'components/select-brand';
import { BrandOption } from 'utils/types';
import { Link } from 'react-router-dom';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import useDashboardContext from 'contexts/dashboard.context';
import Tippy from '@tippyjs/react';

const NewMealCategory = () => {
  const EMPTY_FORM = {
    name: '',
    description: '',
    brand_ids: '',
    horizontal: false
  };
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [selectedBrand, setSelectedBrand] = useState([] as BrandOption[] | undefined);
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { setMealInfo, routePrefix } = useDashboardContext();
  const toggleSuccessModal = () => {
    setShowSuccessModal(!showSuccessModal);
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const confirmDisabled = () => {
    return !formData.name || !formData.description || selectedBrand?.length === 0;
  };

  const addNewCategory = async () => {
    setLoading(true);
    const selectedBrandIds = selectedBrand?.map((item) => item.value);
    const payload = {
      ...formData,
      brand_ids: selectedBrandIds
    };
    try {
      const res = await apiService.post('meal-category', {
        data: payload
      });
      if (res?.data) {
        setShowSuccessModal(true);
        setMealInfo(
          res?.data?.data?.map((item: any) => ({
            brand_id: item.brand_id,
            meal_category_id: item.id
          }))
        );
      }
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error?.response?.data?.message} />);
    }
    setLoading(false);
  };

  return (
    <div className='space-y-12 category-details'>
      <div className='space-y-6'>
        <Input
          type='text'
          label='Category Name'
          placeholder='Enter category name'
          className='w-full mt-4'
          inputClass='px-[20px] py-[14px]'
          value={formData?.name}
          onChange={handleChange}
          name='name'
        />
        <Textarea
          label='Category Description'
          placeholder='Describe the category'
          value={formData?.description}
          onChange={handleChange}
          name='description'
        />

        <div className='flex flex-col gap-1'>
          <p>Search brand(s)</p>
          <SelectBrand brands={selectedBrand || []} setBrands={setSelectedBrand} multiple />
        </div>
        <Tippy
          placement='bottom-start'
          content={
            <p className='bg-white border border-gray-11 p-2 shadow-lg rounded'>
              If enabled, this category will appear as a horizontal scroll section on the mobile
              app.
            </p>
          }>
          <div
            onClick={() => setFormData({ ...formData, horizontal: !formData.horizontal })}
            className='flex items-center gap-2 '>
            <Input
              type='checkbox'
              name='horizontal'
              checked={formData.horizontal}
              checkColor='gray'
              onChange={() => setFormData({ ...formData, horizontal: !formData.horizontal })}
            />
            <p className='text-sm font-medium'>Display Horizontally </p>
          </div>
        </Tippy>
      </div>
      <SingleBottomNav
        onConfirm={addNewCategory}
        btnDisabled={confirmDisabled()}
        loading={loading}
      />

      <SuccessModal
        onClose={toggleSuccessModal}
        show={showSuccessModal}
        link={`${routePrefix}/${ROUTE_KEYS.NEW_MEAL}/${ROUTE_KEYS.NEW_MEAL_BRAND_DETAILS}`}
        linkText='Proceed to add meal to category'>
        <div className='flex flex-col gap-8'>
          Meal category successfully created
          <Button
            color='primary'
            className='text-xs underline tracking-wider underline-offset-2'
            variant='link'>
            <Link to={`${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.OVERVIEW}`}>CLICK TO GO HOME</Link>
          </Button>
        </div>
      </SuccessModal>
    </div>
  );
};

export default NewMealCategory;
